<template>
  <BaseModal @close="$emit('close')">
    <template v-slot:title>Gerenciar Imagens</template>
    <div class="modal-content-wrapper">
      <p class="prod-name-modal">{{ produto.nome }}</p>
      
      <div class="images-grid" v-if="produto.images && produto.images.length > 0">
        <div v-for="(img, idx) in produto.images" :key="idx" class="image-item">
          <img :src="img" alt="Produto" />
          <button class="btn-remove-img" @click="$emit('delete-image', img)" title="Remover imagem">
            <span class="material-icons-outlined">delete</span>
          </button>
        </div>
      </div>
      <div v-else class="empty-images">Sem imagens cadastradas.</div>
      
      <hr class="divider"/>
      
      <div class="upload-area">
        <label class="upload-label">Adicionar Nova Imagem</label>
        <input type="file" ref="fileInput" accept="image/*" @change="handleFile" class="file-input"/>
        
        <div v-if="selectedFile" class="file-preview">
          <span>{{ selectedFile.name }}</span>
          <button @click="limparSelecao" class="btn-clear">Remover</button>
        </div>
      </div>
    </div>
    
    <template v-slot:actions>
      <button @click="$emit('close')" class="modal-btn-no" :disabled="loading">Fechar</button>
      <button @click="enviar" class="modal-btn-yes" :disabled="!selectedFile || loading">
        {{ loading ? 'Enviando...' : 'Enviar Foto' }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '../BaseModal.vue';

export default {
  name: 'ModalImagem',
  components: { BaseModal },
  props: {
    produto: Object,
    loading: Boolean
  },
  data() { return { selectedFile: null }; },
  methods: {
    handleFile(event) { this.selectedFile = event.target.files[0]; },
    limparSelecao() {
      this.selectedFile = null;
      if(this.$refs.fileInput) this.$refs.fileInput.value = '';
    },
    enviar() {
      if (this.selectedFile) this.$emit('upload', this.selectedFile);
    }
  }
};
</script>

<style scoped>
.prod-name-modal { font-size: 1.2rem; font-weight: bold; text-align: center; margin-bottom: 20px; color: var(--color-accent); }
.images-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)); gap: 10px; margin-bottom: 20px; }
.image-item { position: relative; }
.image-item img { width: 100%; height: 80px; object-fit: cover; border-radius: 4px; border: 1px solid var(--border-light); }
.btn-remove-img { position: absolute; top: 4px; right: 4px; background-color: rgba(244, 67, 54, 0.9); color: white; border: none; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; cursor: pointer; transition: transform 0.2s; }
.btn-remove-img:hover { transform: scale(1.1); background-color: #d32f2f; }
.btn-remove-img span { font-size: 16px; }
.empty-images { text-align: center; color: var(--text-secondary); font-style: italic; padding: 10px; }
.divider { border: 0; border-top: 1px solid var(--border-light); margin: 20px 0; }
.upload-area { display: flex; flex-direction: column; gap: 10px; align-items: center; }
.upload-label { font-weight: 600; }
.file-input { border: 1px solid var(--border-light); padding: 10px; border-radius: 6px; width: 100%; }
.file-preview { display: flex; align-items: center; gap: 10px; background: var(--bg-header); padding: 5px 10px; border-radius: 4px; width: 100%; justify-content: space-between; }
.btn-clear { background: none; border: none; color: #F44336; font-size: 0.8rem; cursor: pointer; }
.modal-btn-yes { background-color: #4caf50; color: white; padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; }
.modal-btn-no { padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; background-color: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light); }
</style>